/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Col_WinsInputs */



/**
* | output |
* | --- |
* | "Wins" |
*
* @param {Hof_Col_WinsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const hof_col_wins = /** @type {((inputs?: Hof_Col_WinsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Col_WinsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Victoires")
	if (locale === "es") return /** @type {LocalizedString} */ ("Victorias")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vitórias")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vittorie")
	return /** @type {LocalizedString} */ ("Wins")
});